<template>
  <vs-row>
    <vs-col vs-w="12">
      <h3> Mantenedor de adjuntos para flujos </h3>
      <h5 class="mb-5">
        Estas opciones activas aparecerán en los formularios de la aplicación.
      </h5>
    </vs-col>
    <vs-col vs-lg="12" id="listado-opciones" class="mt-5">
      <vs-row vs-type="flex" vs-align="space-around" vs-justify="space-around">
        <vs-col class="mt-3" vs-sm="12" vs-lg="6">
          <div class="add-new">
            <h4>Tipos de adjuntos</h4>
            <CheckPermission permission="*"> <!-- TODO: set permission -->
              <vs-button
                v-tooltip="'Agregar tipo de adjunto'"
                color="primary"
                class="margin-right"
                @click="createMood = !createMood"
                type="border"
                icon="playlist_add"
              />
            </CheckPermission>
          </div>
          <vs-list class="bg-white mt-3 box-options">
            <div
              v-for="type in typeAttachments"
              class="wrap-list-item"
              :key="type.opcionId"
            >
              <ListItemOptionAttachmentType
                :option="type"
                :type="'category'"
                :selectedCategory="selectedTypeAttachment
                && selectedTypeAttachment.opcionId === type.opcionId"/>
            </div>
          </vs-list>
        </vs-col>
      </vs-row>
    </vs-col>
    <b-modal
      title="Nuevo tipo de adjunto"
      v-model="createMood"
      no-close-on-backdrop
      centered
      hide-footer
    >
      <div>
        <input
          maxlength="10"
          class="input-option input-edit"
          placeholder="Abreviación"
          size="small"
          v-model="option.valor"
        />
      </div>
      <div>
        <input
          maxlength="100"
          class="input-option input-edit"
          placeholder="Nombre de opción"
          size="small"
          v-model="option.descripcion"
        />
      </div>
      <div class="d-flex justify-content-center">
        <vs-button
          color="primary"
          class="mt-3"
          type="border"
          icon="save"
          @click="saveOption()"
        >
          Guardar
        </vs-button>
      </div>
    </b-modal>
  </vs-row>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';

import ListItemOptionAttachmentType from '../components/ListItemOptionAttachmentType';

import CheckPermission from '@/febos/global/usuario/components/CheckPermission';

export default {
  name: 'MantenedorServicios',
  components: { ListItemOptionAttachmentType, CheckPermission },
  data() {
    return {
      createMood: false,
      option: {}
    };
  },
  watch: {
    loading(value) {
      if (!value) {
        this.$vs.loading.close('#listado-opciones > .con-vs-loading');
        return;
      }
      this.$vs.loading({
        container: '#listado-opciones',
        scale: 0.6
      });
    },
    createMood() {
      this.option = {};
    }
  },
  computed: {
    ...mapGetters('Herramientas', [
      'loading',
      'typeAttachments',
      'selectedTypeAttachment'
    ]),
    ...mapGetters('Usuario', [
      'usuarioActual'
    ]),
    ...mapGetters('Empresas', [
      'empresa'
    ])
  },
  methods: {
    ...mapActions('Herramientas', [
      'listCategories',
      'listTypeAttachments',
      'clearTypeAttachments',
      'saveOptions'
    ]),
    async saveOption() {
      if ((this.option.valor && this.option.valor !== '')
        && (this.option.descripcion && this.option.descripcion !== '')) {
        const option = {
          valor: this.option.valor,
          descripcion: this.option.descripcion,
          configuradoPor: this.usuarioActual.id,
          referenciaId: this.empresa.id,
          parametroId: `tipos.doc-adjuntos-ed.${this.option.valor}`,
          orden: this.typeAttachments.length + 1,
          nivel: 0,
          grupoId: 'tipos.doc-adjuntos-ed',
          extra: '{}'
        };
        await this.saveOptions(option);

        await this.listCategories({
          grupoOpcion: 'tipos.doc-adjuntos-ed',
          deshabilitado: 'si'
        });
        this.createMood = false;
      } else {
        this.$bvToast.toast(
          'Tienes que colocar una abreviación / descripción',
          {
            title: '¡Oye!',
            variant: 'warning',
            pauseOnHover: true,
            solid: true,
            autoHideDelay: 4000,
          }
        );
      }
    }
  },
  mounted() {
    this.clearTypeAttachments();
    this.listCategories({
      grupoOpcion: 'tipos.doc-adjuntos-ed',
      deshabilitado: 'si'
    });
  }
};
</script>

<style lang="css" scoped>
  .box-options {
    height: 500px;
    overflow-y: scroll;
  }
  .add-new {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
  }
  .input-option {
    margin-top: 10px;
    width: 100%;
    background: transparent;
  }
  .input-edit {
    border: 1px solid #66258324;
    padding: 4px 4px 6px 4px;
    border-radius: 5px;
  }
</style>
